import { render, staticRenderFns } from "./ButtonDownloadSpreadsheet.vue?vue&type=template&id=760b2553&scoped=true&"
import script from "./ButtonDownloadSpreadsheet.vue?vue&type=script&lang=js&"
export * from "./ButtonDownloadSpreadsheet.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDownloadSpreadsheet.vue?vue&type=style&index=0&id=760b2553&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760b2553",
  null
  
)

export default component.exports